import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/shared/api/constants';
import { GeoLocationService } from 'src/app/shared/services/geo-location.service';
import { GoogleGeolocationResponseModel } from 'src/app/shared/viewModels/google-geo-location-response-model';

@Component({
  selector: 'app-my-location-btn',
  templateUrl: './my-location-btn.component.html',
  styleUrls: ['./my-location-btn.component.scss']
})
export class MyLocationBtnComponent {
  @Input() showLabel = false;
  @Output() locationAvailableEvent = new EventEmitter<google.maps.LatLngLiteral>();

  private subscriptions = new Subscription();
  public isMobile = false;

  constructor(
    private ref: ChangeDetectorRef,
    private geoLocationService: GeoLocationService
  ) {

  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < Constants.xs;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onClick() {
    if (this.isMobile) {
      this.locationAvailableEvent.emit({lat: 0, lng: 0});
      // Geolocation.getCurrentPosition().then(
      //   (coordinates: Position) => {
      //     const lat = coordinates.coords.latitude;
      //     const lng = coordinates.coords.longitude;
      //     onResponseCallback(lat, lng);
      //   }
      // ).catch(_error => undefined);
    } else {
      this.subscriptions.add(
        this.geoLocationService.getPositionFromGoogleGeolocationAPI().subscribe((response: GoogleGeolocationResponseModel) => {
          const lat = response.location.lat;
          const lng = response.location.lng;
          this.locationAvailableEvent.emit({lat: lat, lng: lng});
        })
      );
    }
  }
}
